import { request } from 'utils/requests'

// Puxa do Escavador valor da causa, classe, fase e sugere o resultado da ação.
// opts: { atualizarTribunal?: boolean }
export const enrichProcess = async (processId, opts = {}) => {
  const { data } = await request.post(`/escavador/v2/processos/${processId}/enriquecer`, opts)
  return data
}

// Consumo do mês (consultas + custo recorrente dos monitoramentos). mes = 'AAAA-MM'
export const getEscavadorUsage = async (mes) => {
  const { data } = await request.get('/escavador/v2/usage', { params: mes ? { mes } : {} })
  return data
}

export const RESULTADO_OPTIONS = [
  { value: 'em_andamento', label: 'Em andamento' },
  { value: 'ganho', label: 'Ganho' },
  { value: 'perdido', label: 'Perdido' },
  { value: 'acordo', label: 'Acordo' },
  { value: 'parcial', label: 'Parcialmente procedente' },
]

export const RESULTADO_LABEL = Object.fromEntries(RESULTADO_OPTIONS.map((o) => [o.value, o.label]))

// ---- Consulta de processos por CPF/CNPJ --------------------------------------

export const getEnvolvidoQuota = async () => (await request.get('/consulta-envolvido/cota')).data
export const getEnvolvidoHistory = async () => (await request.get('/consulta-envolvido/historico')).data
// alvo: { modo: 'documento', documento } | { modo: 'nome', nome } | { modo: 'oab', oabNumero, oabUf } (ou string com CPF/CNPJ)
const toAlvo = (alvo) => (typeof alvo === 'string' ? { modo: 'documento', documento: alvo } : alvo)
export const previewEnvolvido = async (alvo) => (await request.post('/consulta-envolvido/preview', { alvo: toAlvo(alvo) })).data
export const executeEnvolvido = async (alvo, confirmacoes, filtros = {}) => (await request.post('/consulta-envolvido/executar', { alvo: toAlvo(alvo), confirmacoes, filtros })).data
export const getEnvolvidoHistoryItem = async (id) => (await request.get(`/consulta-envolvido/historico/${id}`)).data
export const importEnvolvidoProcesses = async (processos, clientId) => (await request.post('/consulta-envolvido/importar', { processos, clientId })).data

// Catálogo de rotas do Escavador usadas pelo sistema + consumo do mês ('AAAA-MM')
export const getEscavadorRoutes = async (mes) => (await request.get('/escavador/v2/usage/rotas', { params: mes ? { mes } : {} })).data

// Saldo de créditos da conta no Escavador
export const getEscavadorBalance = async () => (await request.get('/escavador/v2/saldo')).data
